export const fetchUtility = <T>(url: string, options?: RequestInit): Promise<T | null> => {
  return fetch(url, options).then((response: Response) => {
    if (!response.ok) throw new Error(response.statusText);
    if (response.status === 204) return null;

    return response.json() as Promise<T>;
  });
};
